// The centre's short note on a practice suggestion ("From your centre" in the
// family's app). Same bound as the `assignment.note` check constraint.

export const NOTE_MAX = 280;

/** Games one practice-idea send may carry (create_suggestions). */
export const SUGGESTION_GAMES_MAX = 3;

/** Trim, cap at {@link NOTE_MAX} characters, and return null when empty. */
export function normaliseNote(note: string | null | undefined): string | null {
  if (typeof note !== "string") return null;
  const trimmed = note.trim();
  if (trimmed.length === 0) return null;
  return Array.from(trimmed).slice(0, NOTE_MAX).join("").trim();
}
